import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";

export const FloatingWhatsApp = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 inline-flex items-center gap-2 rounded-full bg-wa-green px-4 py-3 text-sm sm:text-base font-extrabold text-white shadow-lg shadow-wa-green/40 hover:brightness-110 transition"
    aria-label="Chamar no WhatsApp"
    data-testid="floating-whatsapp-btn"
  >
    <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6 shrink-0" />
    <span>Chamar no WhatsApp</span>
  </a>
);
